import { useAction, useAtom } from '@reatom/npm-react'

import { Button } from '@blade/ui-kit'
import { selectedNetworkAtom } from '@root/entities/network/atoms'
import { EyeIcon } from '@root/shared/ui-kit'

import { blacklistCurrenciesModel } from '../atoms'

import type { CurrencyModel } from '@root/entities/currency'
import type { CurrencyRef } from '@root/entities/currency/model'

type Props = {
  currency: CurrencyModel | CurrencyRef.Ref
}

export const BlacklistCurrenciesUnhideCell: React.FC<Props> = ({
  currency,
}) => {
  const unhide = useAction(blacklistCurrenciesModel.unhide)
  const [network] = useAtom(selectedNetworkAtom)
  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation()
    unhide({ address: currency.address, network })
  }

  return (
    <Button
      onClick={handleClick}
      radius="rounded"
      iconLeft={<EyeIcon size={14} />}
      size="h28"
      variant="soft"
    />
  )
}
